import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { Button, SelectionBar, TableV2, BaseModal } from '@anytag/shared-atoms';
import { YoutubeCMSAsset } from '../types';
import { useDeleteYoutubeChannelAssetOwner } from '../hooks';
import { useYoutubeCMSAssetsTable } from './hooks';
import { YoutubeCMSAssetOwnerChannelIdFormValues } from './types';

export type TemplateProps = TableData<YoutubeCMSAsset> &
  Pick<Parameters<typeof useYoutubeCMSAssetsTable>[0], 'type' | 'modifiable'>;

export const Template = ({ type, loading, modifiable, data = [] }: TemplateProps) => {
  const { t } = useTranslation();
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const {
    formState: { isDirty, isSubmitting }
  } = useFormContext<YoutubeCMSAssetOwnerChannelIdFormValues>();
  const { deleting, deletingAssetOwner, setDeletingAssetOwner, resetDeletingAssetOwner, handleDeleteAssetOwner } =
    useDeleteYoutubeChannelAssetOwner();
  const { columns } = useYoutubeCMSAssetsTable({
    type,
    modifiable,
    onSetDeletingAssetOwner: setDeletingAssetOwner
  });

  return (
    <>
      <div className="relative">
        <TableV2
          ref={offsetRef}
          loading={loading}
          maxHeight={defaultTableMaxHeight}
          data={data}
          columns={columns}
          rowHeight="64px"
          noTopBorderRadius
          stickyHeader
        />

        {isDirty && !loading ? (
          <SelectionBar>
            <Button
              type="submit"
              variant="solid"
              id="skipOutsideClick"
              title={t('Button.Save')}
              className="ml-auto px-4"
              loading={{ status: isSubmitting, title: t('Button.Saving') }}
            />
          </SelectionBar>
        ) : null}
      </div>

      <BaseModal
        open={!!deletingAssetOwner}
        onClose={resetDeletingAssetOwner}
        description={t('clearAssetOwnerDescription')}
        title={t('Are you sure you want to clear this owner?')}
        footer={{
          cancelButton: { onClick: resetDeletingAssetOwner },
          submitButton: { loading: deleting, title: t('Button.Remove'), onClick: handleDeleteAssetOwner }
        }}
      />
    </>
  );
};
